<script setup>
import { useCustomerCartState } from '@/store/composables/useCustomerCartState'

const { t } = useI18n()

const cartData = useCustomerCartState()

const totalCartItems = computed(() => {
  if (!cartData.value || !cartData.value.items || !cartData.value.items.length)
    return 0

  return cartData.value.items.reduce((acc, item) => acc + item.quantity, 0)
})
</script>

<template>
  <div class="flex gap-3 py-3">
    <BaseLink
      url="/store/orders"
      class="min-w-110px w-full"
    >
      <DSButton class="w-full flex items-center gap-1 border-1 rounded-lg bg-white p-3 shadow-sm">
        <DSIcon
          icon="i-fas-list"
          size="24"
          class="text-secondary-300"
        />
        <span>{{ t('Orders') }}</span>
      </DSButton>
    </BaseLink>
    <BaseLink
      url="/store/cart"
      class="min-w-110px w-full"
    >
      <DSButton class="w-full flex items-center gap-1 border-1 rounded-lg bg-white p-3 shadow-sm">
        <DSIcon
          icon="i-far-cart-shopping"
          size="24"
          class="text-secondary-300"
        />
        <div class="flex gap-1">
          <span>{{ t('Cart') }}</span>
          <span>({{ totalCartItems }})</span>
        </div>
      </DSButton>
    </BaseLink>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Cart": "Cart",
    "Orders": "Orders",
    "Store": "Store"
  }
}
</i18n>


<i18n locale="de" lang="json">
{
  "Cart": "Warenkorb",
  "Orders": "Bestellungen",
  "Store": "Shop"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Cart": "Carrito",
  "Orders": "Pedidos",
  "Store": "Tienda"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Cart": "Panier",
  "Orders": "Commandes",
  "Store": "Boutique"
}
</i18n>